import React, { useContext } from 'react';
import './Header.css';

import { subtileHeaderFactory } from '../../Helper_functions/Languages/LanguageSelector';
import { LanguageContext } from '../../context/languageContext';
import { getCashedSurveysIds } from '../../Helper_functions/databaseService/databaseService';
import { LanguageIdContext } from '../../context/languageIdContext';
import Modal_pop_up from '../Model_pop_up/Modal_pop_up';
import InstallButton from '../InstallButton/InstallButton';
import Markdown from 'react-markdown';

const Header = () => {
    const { language } = useContext(LanguageContext);
    const { languageId, setLanguageId } = useContext(LanguageIdContext);
    const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = React.useState(false);
    const closeDialog = () => setIsPrivacyPolicyOpen(false);
    const privacyForm = localStorage.getItem('privacy_form') || '';

    const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

        setLanguageId(parseInt(e.target.value));
    };



    return (
        <div className='header_container' style={{ paddingTop: subtileHeaderFactory(language) ? .5 : 14, paddingBottom: subtileHeaderFactory(language) ? .5 : 14 }}>
            <div>
                <h1 className="header_title">MAT Facilitator</h1>
                {subtileHeaderFactory(language) ? <h6 className="header_subtitle">{subtileHeaderFactory(language)}</h6> : null}
                <button className="privacy_policy_button" onClick={() => setIsPrivacyPolicyOpen(true)}>
                    Privacy Policy
                </button>
                <InstallButton />
            </div>

            <div className="header_actions">
                <select className="header_select" value={languageId} onChange={onSelectChange}>
                    {/* <option value="English">English</option>
                    <option value="French">French</option>
                    <option value="Indonesian">Indonesian</option>
                    <option value="Spanish">Spanish</option> */}
                    {getCashedSurveysIds().map((lang) => (
                        <option key={lang.id} value={lang.id}>
                            {lang.name}
                        </option>
                    ))
                    }
                </select>
            </div>
            <Modal_pop_up
                isOpen={isPrivacyPolicyOpen}
                title='Privacy Policy for MAT Facilitator'
                body={<Markdown>{privacyForm}</Markdown>}
                buttonTitle='Close'
                bnt_confirm_onclick={closeDialog}
                disable={false}
            />
        </div>
    );
};

export default Header;
